import { MenuItemDetailScreen } from '@/screens/menu-item/menu-item-detail-screen';
export default MenuItemDetailScreen;
